// extracted by mini-css-extract-plugin
export default {"root":"SectionFrame_root__7wotm","default":"SectionFrame_default__rnS12","narrow":"SectionFrame_narrow__p4cwV"};